import React, { useEffect, useRef, useState } from "react";
import { keyboardLayout } from "../utils/lang";
import ReactKeyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import { SimpleKeyboardLayouts } from "simple-keyboard-layouts";

const defaultLayout = {
  default: [
    "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
    "{tab} q w e r t y u i o p [ ] \\",
    "{lock} a s d f g h j k l ; ' {enter}",
    "{shift} z x c v b n m , . / {shift}",
    ".com @ {space} {Lang}",
  ],
  shift: [
    "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
    "{tab} Q W E R T Y U I O P { } |",
    '{lock} A S D F G H J K L : " {enter}',
    "{shift} Z X C V B N M < > ? {shift}",
    ".com @ {space} {Lang}",
  ],
};

const defaultDisplay = {
  "{numbers}": "123",
  "{ent}": "return",
  "{escape}": "esc ⎋",
  "{tab}": "tab ⇥",
  "{backspace}": "⌫",
  "{capslock}": "caps lock ⇪",
  "{shift}": "⇧",
  "{controlleft}": "ctrl ⌃",
  "{controlright}": "ctrl ⌃",
  "{altleft}": "alt ⌥",
  "{altright}": "alt ⌥",
  "{metaleft}": "cmd ⌘",
  "{metaright}": "cmd ⌘",
  "{abc}": "ABC",
  "{space}": " "
};

const bufferExec = (button, ctx = document) => {
  switch (button) {
    case "{tab}": {
      return window.pdfDoc.execCommand("insertText", undefined, "\t");
    }
    case "{bksp}" : 
    case "{backspace}" :{
      return window.pdfDoc.execCommand("delete");
    }
    case "{space}": {
      return window.pdfDoc.execCommand("insertText", undefined, " ");
    }
    case "{enter}":
    case "{ent}" : {
      return window.pdfDoc.execCommand("insertText", undefined, "\n");
    }
    default: {
      return window.pdfDoc.execCommand("insertText", undefined, button);
    }
  }
};

export default function VKeyboard(props) {
  const keyboard = useRef();
  const { layout, display } = new SimpleKeyboardLayouts()?.get(props.layout) || {
    layout: keyboardLayout?.[props.layout] || defaultLayout,
  
  };

  const [layoutName, setLayoutName] = useState("default");

  const onKeyPress = (button) => {
    if (button === "{shift}" || button === "{lock}") {
      return handleShift();
    }
    if (button === "{numbers}" || button === "{abc}") {
      return handleNumbers();
    }
    bufferExec(button, props.ctx);
  };

  const handleShift = () => {
    switch (layoutName) {
      case "default": {
        setLayoutName("shift");
        break;
      }
      case "shift": {
        setLayoutName("default");
        break;
      }
      default:
        break;
    }
  };

  const handleNumbers = () => {
    let currentLayout = layoutName;
    let numbersToggle = currentLayout !== "numbers" ? "numbers" : "default";
    setLayoutName(numbersToggle);
  };

  const mode = "light";
  const [onScreen, setOnScreen] = useState(false);

  if (props.onScreen) {
    const docInput = document.querySelector('input[type="text"]');
    const docArea = document.querySelector("textarea");
    
    docInput?.addEventListener("keydown", (e) => {
      if (e.key === "X" && e.ctrlKey && e.shiftKey) {
        e.preventDefault();
        
        setOnScreen(true);
      }
    });
  }

 
 
  return (
    <div
      className={props.className || ""}
      style={{ width: "100%", ...props.style }}
    >
      {props.open && (
        <ReactKeyboard
            
            preventMouseDownDefault={true}
            syncInstanceInputs={true}
            newLineOnEnter={true}
            onChange={props.onChange}
            onChangeAll={props.onChangeAll}
            onKeyPress={onKeyPress}
            layoutName={layoutName}
            layout={layout}
           
          
        />
      )}
    </div>
  );
  }
  
